import { RootState } from '../../../store/types';

export const getOpenSettingsPanel = (state: RootState): boolean => state.openSettingsPanelState.openSettingsPanel;



